import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function DashboardPage() {
  const { profile, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && profile) {
      // Redirect based on user role
      switch (profile.role) {
        case 'admin':
          navigate('/dashboard/admin', { replace: true });
          break;
        case 'trainer':
          navigate('/dashboard/trainer', { replace: true });
          break;
        case 'client':
        default:
          navigate('/dashboard/client', { replace: true });
          break;
      }
    }
  }, [profile, loading, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
        <p className="mt-4 text-sm text-gray-600">Loading dashboard...</p>
      </div>
    </div>
  );
}
